import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import {
  getAuth,
  signInWithRedirect,
  getRedirectResult,
  onAuthStateChanged,
  GoogleAuthProvider,
} from "firebase/auth";
import GameSelection from "./components/GameSelection";
import ChessBoard from "./components/ChessBoard";
import ResponsiveAppBar from "./components/ResponsiveAppBar.tsx";

const App = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [background, setBackground] = useState({
    image: `${process.env.PUBLIC_URL}/images/background_1_1.jfif`,
    size: "cover",
    position: "center",
  });

  const auth = getAuth();

  const handleLogin = async () => {
    const provider = new GoogleAuthProvider();
    setLoading(true);
    try {
      await signInWithRedirect(auth, provider);
    } catch (err) {
      console.error("Error during login:", err);
      setError(err.message);
      setLoading(false);
    }
  };

  const checkRedirectResult = async () => {
    try {
      const result = await getRedirectResult(auth);
      if (result) {
        console.log("User signed in via redirect:", result.user);
        setUser(result.user);
        alert("/main");
      }
    } catch (err) {
      console.error("Error during redirect sign-in:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkRedirectResult();

    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        console.log("User is signed in:", currentUser);
        setUser(currentUser);
      } else {
        console.log("No user is signed in.");
        setUser(null);
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <Router>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          width: "100vw",
          height: "100vh",
          backgroundImage: `url(${background.image})`,
          backgroundSize: background.size,
          backgroundPosition: background.position,
          backgroundRepeat: "no-repeat",
        }}
      >
        <div
          style={{
            position: "fixed",
            top: 0,
            width: "100%",
            zIndex: 1000,
          }}
        >
          <ResponsiveAppBar user={user} />
        </div>

        <div
          style={{
            display: "flex",
            flex: 1,
            alignItems: "center",
            justifyContent: "center",
            paddingTop: "64px", // Ensure space for the fixed app bar
          }}
        >
          {error && <div style={{ color: "red" }}>Error: {error}</div>}
          <Routes>
            <Route
              path="/main"
              element={<GameSelection onGameStart={() => setLoading(true)} />}
            />
            <Route
              path="/chess"
              element={
                <ChessBoard
                  generalMessage={null}
                  onGoToTimeSelection={() => alert("/main")}
                />
              }
            />
            <Route
              path="/"
              element={
                <div>
                  <h1>Welcome to Democratic Chess</h1>
                  {!user ? (
                    <button onClick={handleLogin} disabled={loading}>
                      {loading ? "Loading..." : "Sign in with Google"}
                    </button>
                  ) : (
                    <button onClick={() => alert("/main")}>Go to Game</button>
                  )}
                </div>
              }
            />
          </Routes>
        </div>
      </div>
    </Router>
  );
};

export default App;
